import { useMemo } from "react";
import {
  useGetUserBalanceStatusQuery,
  useGetUserStatsQuery,
} from "../api/statsApi";
import { TierIcon, TierCode } from "entities/tier";
import { TwoFactorAuthList } from "features/two-factor-auth";

import styles from "./Stats.module.css";

export const Stats = () => {
  const { data, isLoading } = useGetUserStatsQuery();
  const { data: balanceStatus } = useGetUserBalanceStatusQuery();

  const percent = useMemo(() => {
    if (!data || !data.trades) return 0;
    return Math.round((data.profitable_trades / data.trades) * 100);
  }, [data]);

  const userTier = balanceStatus?.status.tier;

  const getProfitableStyle = (value: number) =>
    value < 50 ? styles.yellowBg : styles.greenBg;
  const getProfitStyle = (value: number) =>
    value < 0 ? styles.redBg : styles.greenBg;

  return (
    <>
      {isLoading && (
        <div className={styles.loading}>
          <div className={styles.spinner} />
          Loading...
        </div>
      )}
      {data && (
        <div className={styles.stats}>
          <ul className={styles.list}>
            <li className={styles.item}>
              <span className={styles.label}>Trades:</span>
              <span className={styles.value}>{data.trades}</span>
            </li>

            <li className={`${styles.item} ${getProfitableStyle(percent)}`}>
              <span className={styles.label}>Profitable trades:</span>
              <span className={styles.value}>{percent}</span>
              <span className={styles.unit}>%</span>
            </li>

            <li className={styles.item}>
              <span className={styles.label}>Trading turnover:</span>
              <span className={styles.unit}>$</span>
              <span className={styles.value}>{data.trading_turnover}</span>
            </li>

            <li
              className={`${styles.item} ${getProfitStyle(Number(data.trading_profit))}`}
            >
              <span className={styles.label}>Trading profit:</span>
              <span className={styles.unit}>$</span>
              <span className={styles.value}>{data.trading_profit}</span>
            </li>

            <li className={styles.item}>
              <span className={styles.label}>Max trade:</span>
              <span className={styles.unit}>$</span>
              <span className={styles.value}>{data.max_trade}</span>
            </li>

            <li className={styles.item}>
              <span className={styles.label}>Min trade:</span>
              <span className={styles.unit}>$</span>
              <span className={styles.value}>{data.min_trade}</span>
            </li>

            <li className={styles.item}>
              <span className={styles.label}>Max profit:</span>
              <span className={styles.unit}>$</span>
              <span className={styles.value}>{data.max_profit}</span>
            </li>

            <li className={styles.item}>
              <span className={styles.label}>Tier:</span>
              {userTier ? (
                <TierIcon tier={userTier as TierCode} size={28} />
              ) : (
                <span className={styles.value}>—</span>
              )}
            </li>
            <li className={styles.item}>
              <span className={styles.label}>2FA:</span>
              <TwoFactorAuthList />
            </li>
          </ul>
        </div>
      )}
    </>
  );
};
